/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockInboundDetailExportDto } from './StockInboundDetailExportDto';
import {
    StockInboundDetailExportDtoFromJSON,
    StockInboundDetailExportDtoFromJSONTyped,
    StockInboundDetailExportDtoToJSON,
    StockInboundDetailExportDtoToJSONTyped,
} from './StockInboundDetailExportDto';

/**
 * 
 * @export
 * @interface ResponseListStockInboundDetailExportDto
 */
export interface ResponseListStockInboundDetailExportDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockInboundDetailExportDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockInboundDetailExportDto
     */
    message?: string;
    /**
     * 
     * @type {Array<StockInboundDetailExportDto>}
     * @memberof ResponseListStockInboundDetailExportDto
     */
    data?: Array<StockInboundDetailExportDto>;
}

/**
 * Check if a given object implements the ResponseListStockInboundDetailExportDto interface.
 */
export function instanceOfResponseListStockInboundDetailExportDto(value: object): value is ResponseListStockInboundDetailExportDto {
    return true;
}

export function ResponseListStockInboundDetailExportDtoFromJSON(json: any): ResponseListStockInboundDetailExportDto {
    return ResponseListStockInboundDetailExportDtoFromJSONTyped(json, false);
}

export function ResponseListStockInboundDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockInboundDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockInboundDetailExportDtoFromJSON)),
    };
}

export function ResponseListStockInboundDetailExportDtoToJSON(json: any): ResponseListStockInboundDetailExportDto {
    return ResponseListStockInboundDetailExportDtoToJSONTyped(json, false);
}

export function ResponseListStockInboundDetailExportDtoToJSONTyped(value?: ResponseListStockInboundDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockInboundDetailExportDtoToJSON)),
    };
}

